// extracted by mini-css-extract-plugin
module.exports = {"container":"Breadcrumb_container__6S0ir","path":"Breadcrumb_path__5UYw4","link":"Breadcrumb_link__sGbgY","currentPath":"Breadcrumb_currentPath__53jYp"};